/** @jsxImportSource @emotion/react */

import Typography from '@mui/material/Typography'
import { noop } from 'lodash'
import { TabsItem } from 'types/tabsItem'
import * as classes from './styles'

export type TabsProps<T extends TabsItem> = {
  tabs: T[]
  value: T
  onChange?: (value: T) => void
  renderTabTitle?: (value: T) => string | undefined
  className?: string
}

export function TabsNavigation<T extends TabsItem>({ tabs, value, onChange, renderTabTitle, className }: TabsProps<T>) {
  return (
    <div data-testid="tabs" css={classes.tabsContainer} className={className}>
      {tabs.map((tab) => (
        <Typography
          variant="body2"
          css={[classes.tab({ active: tab.id === value.id, error: tab.error, disabled: tab.disabled })]}
          key={tab.id}
          onClick={() => (tab.disabled ? noop : onChange?.(tab))}
          data-testid={`tab-${tab.id}`}
          data-active={tab.id === value.id}
        >
          {renderTabTitle?.(tab) ?? tab.title}
        </Typography>
      ))}
    </div>
  )
}

export default TabsNavigation
